/**
 * Table Settings Feature для CrudResource
 *
 * При відкритті списку резолвить налаштування колонок таблиці та полів фільтра
 * на сервері (персональна опція АБО глобальний дефолт ресурсу — fallback рахує
 * бекенд) і наповнює кеш userManager.
 *
 * Інтегрується через: CrudResourceContext -> eventManager.emit('onAfterInit') -> InitTableSettings
 * (за аналогією з AddTableViewModeToList).
 */

import { userManager } from '@/Core/Managers'
import { getFilterFieldsOptionKey, getTableColumnsOptionKey } from '@/Core/UI/CrudResource/Helpers/tableSettings'

/**
 * Резолвить налаштування списку (колонки + фільтр) при ініціалізації.
 *
 * Резолвимо ЗАВЖДИ, без шорткату «вже в кеші»: кеш гідратується з localStorage
 * і може містити застарілий адмінський дефолт або видалену персональну опцію —
 * локальне значення дає миттєвий рендер, а resolved освіжає його у фоні.
 * Конкурентні виклики від інших crud-компонентів сторінки UserManager склеює
 * в один HTTP-запит, тож повторних/зайвих запитів це не породжує.
 *
 * @param crudContext - контекст CRUD ресурсу
 */
export const InitTableSettings = async ({ crudContext }: { crudContext: any }) => {
    if (!crudContext || crudContext.contextType === 'detail') return

    const resourceKey = crudContext.resource?.key
    if (!resourceKey) return

    // Чекаємо гідратацію localStorage: до неї кеш порожній (хибний промах),
    // а після — може бути перезаписаний нею (втрата щойно завантажених значень)
    await userManager.waitForHydration()

    // Помилки ковтаються всередині resolveUserOptions — при недоступності сервера
    // працюємо на локальному кеші та дефолтах
    userManager.resolveUserOptions([getTableColumnsOptionKey(resourceKey), getFilterFieldsOptionKey(resourceKey)])
}
